import { INPUT, INPUT_TYPES } from '$gbusiness/enums';
import InputRowModel from '$gbusiness/models/inputRow';
import { input } from '$gbusiness/helpers';
import COUPON_TYPE_OPTIONS, { COUPON_TYPE } from '$fbusiness/enums/couponType';

export const COUPON_FORM: Array<InputRowModel> = [
  {
    items: [
      {
        label: 'SCREEN.COUPONS.COLS.CODE',
        value: 'code',
        input: INPUT.TEXT,
        gridSize: 6,
        validation: [input.requiredValidation],
        placeholder: 'SAVE20',
      },
      {
        label: 'SCREEN.COUPONS.COLS.NAME',
        value: 'name',
        input: INPUT.TEXT,
        gridSize: 6,
        validation: [input.requiredValidation],
        placeholder: '20% Off Everything',
      },
      {
        label: 'SCREEN.COUPONS.COLS.DESCRIPTION',
        value: 'description',
        input: INPUT.TEXTAREA,
        gridSize: 12,
        placeholder: 'Get 20% off your entire order',
      },
      {
        label: 'SCREEN.COUPONS.COLS.TYPE',
        value: 'type',
        input: INPUT.SELECT,
        gridSize: 6,
        validation: [input.requiredValidation],
        options: COUPON_TYPE_OPTIONS,
      },
      {
        ...INPUT_TYPES.PERCENT,
        value: 'discount_value',
        label: 'SCREEN.COUPONS.COLS.DISCOUNT_PERCENT',
        gridSize: 6,
        validation: [input.requiredValidation],
        isHidden: (vals) => vals?.type !== COUPON_TYPE.PERCENT,
      },
      {
        ...INPUT_TYPES.AMOUNT,
        value: 'discount_value',
        label: 'SCREEN.COUPONS.COLS.DISCOUNT_AMOUNT',
        gridSize: 6,
        disableFastField: true,
        validation: [input.requiredValidation],
        isHidden: (vals) => vals?.type !== COUPON_TYPE.FIXED,
      },
      {
        label: 'SCREEN.COUPONS.COLS.APPLIES_TO',
        value: 'applies_to',
        input: INPUT.SELECT,
        gridSize: 6,
        disableFastField: true,
        validation: [input.requiredValidation],
        options: [
          { value: 'all', labelText: 'All Products' },
          { value: 'categories', labelText: 'Specific Categories' },
          { value: 'products', labelText: 'Specific Products' },
        ],
      },
      {
        ...INPUT_TYPES.AMOUNT,
        value: 'min_order_amount',
        label: 'SCREEN.COUPONS.COLS.MIN_ORDER',
        gridSize: 6,
        placeholder: 'Optional',
      },
      {
        label: 'SCREEN.COUPONS.COLS.START_DATE',
        value: 'start_date',
        input: INPUT.DATE,
        gridSize: 6,
        placeholder: 'Optional',
      },
      {
        label: 'SCREEN.COUPONS.COLS.END_DATE',
        value: 'end_date',
        input: INPUT.DATE,
        gridSize: 6,
        placeholder: 'Optional',
      },
      {
        label: 'SCREEN.COUPONS.COLS.MAX_REDEMPTIONS',
        value: 'max_redemptions',
        input: INPUT.NUMBER,
        gridSize: 6,
        placeholder: 'Unlimited',
      },
      {
        label: 'SCREEN.COUPONS.COLS.MAX_USES_PER_CUSTOMER',
        value: 'max_uses_per_customer',
        input: INPUT.NUMBER,
        gridSize: 6,
        placeholder: 'Unlimited',
      },
      {
        label: 'SCREEN.COUPONS.COLS.ACTIVE',
        value: 'is_active',
        input: INPUT.CHECKBOX,
        gridSize: 12,
      },
    ],
  },
];
